import type { ActionType } from "typesafe-actions";
import { getType } from "typesafe-actions";

import * as CurrencySelectionActions from "./actions";
import type { ICurrencySelectionState } from "./types";

export type CurrencySelectionAction = ActionType<typeof CurrencySelectionActions>;

// use for initialisation and reset
const resetModalState = {
  isModalOpen: false,
  currentCurrency: null! as string,
  availableCurrencies: null! as string[]
};

const initialCurrencySelectionState: ICurrencySelectionState = {
  ...resetModalState
};

export default function sparepartAssemblyReducer(
  state: ICurrencySelectionState = initialCurrencySelectionState,
  action: CurrencySelectionAction
): ICurrencySelectionState {
  switch (action.type) {
    case getType(CurrencySelectionActions.openCurrencySelectionModal): {
      return {
        ...state,
        isModalOpen: true
      };
    }

    case getType(CurrencySelectionActions.setCurrencySelectionModalData): {
      const { currentCurrency, availableCurrencies } = action.payload;
      return {
        ...state,
        currentCurrency,
        availableCurrencies
      };
    }

    case getType(CurrencySelectionActions.closeCurrencySelectionModal): {
      return {
        ...state,
        isModalOpen: false
      };
    }

    case getType(CurrencySelectionActions.updateCurrencySelectionModal): {
      const { selectedCurrency } = action.payload;
      return {
        ...state,
        isModalOpen: false,
        currentCurrency: selectedCurrency
      };
    }

    case getType(CurrencySelectionActions.clearCurrencySelectionData): {
      return {
        ...state,
        ...resetModalState
      };
    }

    default:
      return state;
  }
}
